import {
    FORM_SUBMIT_BEGIN,
    FORM_SUBMIT_SUCCESS,
    FORM_SUBMIT_FAIL
  } from '../middleware/types'
  
  const initialState = {
    SUBMIT_loading: false,
    error: {},
    response:{}
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FORM_SUBMIT_BEGIN:
        return {
          ...state,
          SUBMIT_loading: true
        }
      case FORM_SUBMIT_SUCCESS:
          return {
              ...state,
              SUBMIT_loading: false,
              response: action.payload
            }
      case FORM_SUBMIT_FAIL:
        return {
          ...state,
          SUBMIT_loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }